import { z } from 'zod';

import { LOS_DUPLICATE_MESSAGE, LOS_REQUIRED_MESSAGE, LOS_MAX_LENGTH } from '../../constants';
import { getLOSBaseSchema } from '../../utils';

const MAX_LENGTH_FOR_LOS_CREATION = 2048;

const baseSchema = getLOSBaseSchema(MAX_LENGTH_FOR_LOS_CREATION);

export const AddLOSFormInput = z.object({
  los: baseSchema.superRefine((input, ctx) => {
    const transformedInput = input.split('\n').map((str) => str.trim());

    if (!transformedInput.length) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: LOS_REQUIRED_MESSAGE,
      });
    }

    const isAllStringInArrayUnique =
      [...new Set(transformedInput)].length === transformedInput.length;

    if (!isAllStringInArrayUnique) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: LOS_DUPLICATE_MESSAGE,
      });
    }

    const hasLineExceedingMax = transformedInput.some((str) => {
      return str.length > LOS_MAX_LENGTH;
    });

    if (hasLineExceedingMax) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `มีวัตถุประสงค์การเรียนรู้ที่ยาวเกิน ${LOS_MAX_LENGTH} ตัวอักษร`,
      });
    }
  }),
});

export type AddLOSFormValues = z.infer<typeof AddLOSFormInput>;
